import {computed, observable, toJS} from "mobx";
import {FormComponent} from "../FormsState";
import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import FirebaseSignUpService from "../../../../services/firebase/functions/FirebaseSignUpService";
import {
    ISignupBankInfo,
    ISignupCreateRequest,
    ISignupRetriveStateRequest,
    ISignupStoreStateRequest,
    IWeWorkApplicationRequest,
    LeadPlanType
} from "shared/functions/membersApi/types/ISignupProcess"
import {Cookies} from 'react-cookie';
import MixPanelAnalyticsService from "../../../../services/Analytics/MixPanelAnalyticsService";
import {AnalyticsSignUpEvents} from "../../../../services/Analytics/AnalyticsSignUpEvents";
import {IBankAccountsData} from "../../../../../../shared/src/functions/membersApi/types/ISignupProcess";
import GoogleAnalyticsService from "../../../../services/Analytics/GoogleAnalyticsService";
import {FileStatus} from "../../../../components/FormFileInput/FileStatus";
import {FormVerificationTexts} from "../../screens/SignUpForm/FormVerification/FormVerificationTexts";
import {IGooglePlace} from "shared/model/ICoworkGeoLocation";
import {SBAPages} from "../../screens/FormSBA/FormSBASteps/SBATypes";


export class SignUpFormStateStore extends ApiCallObservable {
    @observable public uid: string = "";
    @observable public _monthlyPaymentAmount: number = -1;
    @observable public _installments: number = 0;
    @observable public _monthlyRepayment: number = 0;
    @observable public _currentComponent: number = FormComponent.welcome;
    @observable public navigationController = {};
    @observable public pdfFile: boolean;
    @observable public formInput: any = {
        verification: {},
        business: {}
    };
    @observable public isEmailValid: boolean = true;
    @observable public plaidError: boolean = false;
    @observable public rentLoanAmountError: boolean = false;
    @observable public paymentError: boolean | string = false;
    @observable public isVerified: boolean = false;
    @observable public _workspaceError: boolean = false;
    @observable public _loading: boolean = false;
    @observable public showResetFormButton: boolean = true;
    @observable public allowImageDelete: boolean = true;
    @observable public showVerifiedCheckmark: boolean = false;
    @observable public showFinishPaymentAnimation: boolean = false;
    @observable public registeredMailAddress: string = '';
    @observable public isPdfSelectAllowed: boolean = false;
    @observable public isPaymentSending: boolean = false;
    @observable public isUpdateCardFinished: boolean = false;
    @observable public WWModalPlaidFlag: boolean = false;
    @observable public isQuickApplication: boolean = false;
    @observable public referralId: string | undefined = undefined;
    @observable public accounts: IBankAccountsData;
    @observable public _isPaymentError: boolean = false;

    @computed
    get currentComponent() {
        return this._currentComponent;
    };

    @computed
    get workspaceError() {
        return this._workspaceError;
    };

    get isLoading() {
        return this._loading;
    };

    @computed
    get coWorkName() {
        return this.formInput.welcome.cowork && this.formInput.welcome.cowork.name? toJS(this.formInput.welcome.cowork.name): toJS(this.formInput.welcome.cowork);
    };

    @computed
    get getmonthlyPaymentAmount() {
        return this._monthlyPaymentAmount;
    };

    get installments() {
        return this._installments;
    };

    get monthlyRepayment() {
        return this._monthlyRepayment;
    };

    public setPaymentError = (val: boolean) => {
        this._isPaymentError = val;
    };

    get isPaymentError() {
        return this._isPaymentError;
    }

    public setUID = (Uid: string) => {
        this.uid = Uid;
    };

    public setWorkspaceError = (val: boolean) => {
        this._workspaceError = val;
    };

    public setIsLoading = (val: boolean) => {
        this._loading = val;
    };

    public updateCurrentComponent = (newComponent: number) => {
        window.scrollTo(0, 0);
        this._currentComponent = newComponent;
    };

    public setMonthlyPaymentAmount = (val: number) => {
        this._monthlyPaymentAmount = val;
    };

    public setInstallmentsPlan = (val: number) => {
        this._installments = val;
    };

    public setRepaymetAmount = (val: number) => {
        this._monthlyRepayment = val;
    };

    public  updateFormData = (data: any) => {
        this.handleResponseUserInfoIfNeeded(data.userInfo);
        this.handleResponseRentInfoIfNeeded(data.rentInfo);
        this.handleResponseLoanInfoIfNeeded(data.loanInfo);
        this.handleResponseDepositInfoIfNeeded(data.depositInfo);
        this.handleResponseBankAccountsDataIfNeeded(data.bankAccounts);
        this.handleResponseVerificationInfoIfNeeded(data.verificationInfo);
        this.handleResponsePaymentInfoIfNeeded(data.paymentInfo);
    };

    public getFormComponent = (value: number, data: any) => {
        switch (value) {
            case FormComponent.welcome:
            case FormComponent.planSelect: return value === FormComponent.planSelect && data.userInfo.businessName? FormComponent.financial : FormComponent.business;
            case FormComponent.business: return FormComponent.financial;
            case FormComponent.financial: return FormComponent.bankSelection;
            case FormComponent.bankSelection:
            case FormComponent.verification:
            case FormComponent.payment: return FormComponent.verification;
            case FormComponent.finish: return FormComponent.payment;
            default: return FormComponent.welcome;
        }
    };

    public async getUserStage(uid: string) {
        const params: ISignupRetriveStateRequest = {
            uid
        };
        const response = await FirebaseSignUpService.retrieveUserData(params);
        if(response.ok) {
            this.updateFormData(response.data);
            const selectedStage = this.getFormComponent(response.data.stage, response.data);
            this.updateCurrentComponent(selectedStage);
            this.setIsLoading(false);
        }
    }

    public async createNeUser() {
        if(!this.formInput.business.userEmail) {
            return;
        }
        const params: ISignupCreateRequest = {
            userInfo: {
                coworkLocation : this.formInput.welcome.cowork,
                name : this.formInput.business.fullName,
                email : this.formInput.business.userEmail,
                planType : this.formInput.plans.plansValue
            }
        };
        params.refCode  = this.referralId? this.referralId: undefined;
        const response = await FirebaseSignUpService.createUser(params);
        if(response.ok && this.formInput.business) {
            this.isEmailValid = true;
            this.registeredMailAddress = this.formInput.business.userEmail;
            this.setUID(response.data.uid);
            const cookies = new Cookies();
            cookies.set('uid', this.uid, { path: '/' });
        }else {
            this.isEmailValid = false;
        }
    }

    public async resetUser() {
        const params = {uid: this.uid};
        FirebaseSignUpService.resetUser(params);
    }

    public updateBusinessStage = () => {
        const {userCellPhone, userAddress, fullName, userEmail, userCompanyName, businessType} = this.formInput.business;
        const params: ISignupStoreStateRequest = {
            uid: this.uid,
            stage: 2,
            userInfo: {
                coworkLocation : this.formInput.welcome.cowork,
                name : fullName,
                email : userEmail,
                planType : this.formInput.plans.plansValue,
                businessName: userCompanyName,
                userCellPhone,
                userAddress,
                businessType
            }
        };
        this.updateUserState(params);
    };

    public updateFinance = () => {
        const params: ISignupStoreStateRequest = {
            uid: this.uid,
            stage: 3,
        };
        if(this.formInput.plans.plansValue === LeadPlanType.Rent) {
            params.rentInfo = {
                rentAmount: this.formInput.financial.amount,
                installmentPlan: this.formInput.financial.installmentPlan
            }
        }else if(this.formInput.plans.plansValue === LeadPlanType.Loan) {
            params.loanInfo = {
                loanAmount : parseInt(this.formInput.financial.amount, 10),
                installmentPlan: this.formInput.financial.installmentPlan,
                fundingReason: this.formInput.financial.fundReason
            }
        } else if (this.formInput.plans.plansValue === LeadPlanType.Deposit) {
            params.depositInfo = {
                hasPaidDeposit : this.formInput.financial.isDepositPaid,
                isSkipAmount: !this.formInput.financial.amount
            }
            if(this.formInput.financial.amount &&  params.depositInfo) {
                params.depositInfo.depositAmount = parseInt(this.formInput.financial.amount, 10);
            }
        }
        this.updateUserState(params);
    }

    public updateBankDetails = (data: ISignupBankInfo, propertyName: string) => {
        this.setIsLoading(true);
        const params: ISignupStoreStateRequest = {
            uid: this.uid,
            stage: 4
        };
        if(data) {
            params.bankInfo = data;
        }

        this.updateUserState(params, propertyName);
    };

    public updateSelectedAccountDetails = () => {
        const params: ISignupStoreStateRequest = {
            uid: this.uid,
            stage: 5,
            bankAccountDetails: this.formInput.bankAccountDetails
        };
        this.updateUserState(params, "bankSelection");
    };

    public updateIdImage = (data: any, propertyName: string) => {
        const params = {
            uid: this.uid,
            stage: 6,
            verificationInfo: {
                imageDataUri : data,
            }
        };
        this.formInput.verification.idImage = FileStatus.sending;
        this.updateUserState(params, propertyName);
    };

    public updateMembership = (data?: any) => {
        const params: ISignupStoreStateRequest = {
            uid: this.uid,
            stage: 7
        };
        if(data) {
            this.formInput.verification.signupPdfFile = FileStatus.sending;
            params.verificationInfo = {
                membershipAgreementData: data
            };
        } else {
            params.verificationInfo = {
                membershipAgreementData : '',
            };
        }

        const properyName = data? FormVerificationTexts.propertyNames.SIGNUP_PDF : undefined;
        this.updateUserState(params, properyName);
    };

    public updateVerification = () => {
        const params: ISignupStoreStateRequest = {
            uid: this.uid,
            stage: 8
        };
        if (this.formInput.contactEmail) {
            params.verificationInfo = {
                operatorEmail: this.formInput.contactEmail.trim()
            };
        }else if(this.formInput.verification.leadSSN) {
            params.verificationInfo = {
                ssn: this.formInput.verification.leadSSN
            };
        }
        this.updateUserState(params, "verificationFinish");
    };

    public updatePayment = async (data: any) =>  {
        this.setPaymentError(false);
        const params = {
            uid: this.uid,
            stage: 9,
            paymentInfo: {
                opaqueCardInfo: {
                    ...data
                }
            }
        };
        return this.updateUserState(params, "paymentForm");
    };

    public async updateUserState(params: any, propertyName?: string) {
        this.setSending();
        const response = await FirebaseSignUpService.updateUser(params);
        this.setIsLoading(false);
        this.handleUpdateSignupResponse(response, propertyName);
    }

    public handleUpdateSignupResponse = (response: any, propertyName: string | undefined) => {
        if(propertyName === FormVerificationTexts.propertyNames.IMAGE_ID) {
            this.isPdfSelectAllowed = true;
        }
        if (response.ok && response.data) {
            this.handleSuccessfulResponse(response, propertyName);
            this.setSuccessfulResponse(response.data);
        } else {
            this.setError(response.data);
            this.handleErrorResponse(propertyName);
        }
    }

    public async sendWWPlaidData(data: any){
        this.WWModalPlaidFlag = true;
        this.isVerified  = true;
        const params: IWeWorkApplicationRequest = {
            fullName: this.formInput.weWorkDemo.WWfullName,
            companyName: this.formInput.weWorkDemo.WWuserCompanyName,
            userEmail: this.formInput.weWorkDemo.WWuserEmail,
            userPhone: this.formInput.weWorkDemo.WWuserPhone,
            userSSN: this.formInput.weWorkDemo.WWuserSSN,
            isFirstOffice: this.formInput.weWorkDemo.WWfirstOffice,
            securityDepositAmount: this.formInput.weWorkDemo.WWdeposit,
            bankInfo : data
        };
        await FirebaseSignUpService.createWeWorApplication(params);
    }

    public setSearchLocationResult(propertyName : string, val: IGooglePlace | string, formPageName: SBAPages) {
        // tslint:disable-next-line: prefer-conditional-expression
        if ((val as IGooglePlace).formattedAddress) {
            this.formInput[formPageName][propertyName] = (val as IGooglePlace).formattedAddress
        } else {
            this.formInput[formPageName][propertyName] = val
        }
    }

    private handleSuccessfulResponse = (response: any, propertyName: string | undefined) => {
        switch (propertyName) {
            case FormVerificationTexts.propertyNames.IMAGE_ID:
            case FormVerificationTexts.propertyNames.SIGNUP_PDF: {
                this.onFileUploadFinish(response, propertyName);
                break;
            }
            case "plaidConnection": {
                this.onPlaidConnectionFinish(response);
                break;
            }
            case "paymentForm": {
                this.onPaymentFormFinish();
                break;
            }
            case "bankSelection": {
                this.updateCurrentComponent(FormComponent.verification);
                break;
            }
            case "verificationFinish": {
                this.updatePaymentForm(response.data.paymentInfo);
                const mixpanelValue = this.isVerified? "PriceQuotePayment" : "VerifyPayment";
                MixPanelAnalyticsService.track(AnalyticsSignUpEvents[mixpanelValue]);
                this.updateCurrentComponent(FormComponent.payment);
                break;
            }
            default: break;
        }
    }

    private handleErrorResponse = (propertyName: string | undefined) => {
        switch (propertyName) {
            case FormVerificationTexts.propertyNames.IMAGE_ID: {
                this.formInput.verification.idImage = FileStatus.failure;
                MixPanelAnalyticsService.track(AnalyticsSignUpEvents.IDFailure, {userInfo: this.formInput.business});
                break;
            }
            case FormVerificationTexts.propertyNames.SIGNUP_PDF: {
                this.formInput.verification.signupPdfFile = false;
                break;
            }
            case "plaidConnection": {
                this.plaidError = true;
                break;
            }
            case "paymentForm": {
                this.isPaymentSending = false;
                this._loading = false;
                this.paymentError = "Card verification failed. Please check your information and try again.";
                this.setError("Failed fetching summary");
                this.setPaymentError(true)
                break;
            }
            default: break;
        }
    };

    private updatePaymentForm = (paymentInfo: any) => {
        this.setMonthlyPaymentAmount(paymentInfo.montlyFee);
        this.setInstallmentsPlan(paymentInfo.installmentPlan);
        this.setRepaymetAmount(paymentInfo.repaymentAmount);
        this.isVerified = paymentInfo.finalPrice;
    }

    private onPaymentFormFinish = () => {
        this.showFinishPaymentAnimation = true;
        this.isPaymentSending = false;
        MixPanelAnalyticsService.track(AnalyticsSignUpEvents.PaymentApproved);
        GoogleAnalyticsService.triggerEvent("signup", "form submission", "payment verification");
        this.isVerified? MixPanelAnalyticsService.track(AnalyticsSignUpEvents.ApplicationApproved) : MixPanelAnalyticsService.track(AnalyticsSignUpEvents.ApplicationUnderReview);
        setTimeout(() => {
            this.showFinishPaymentAnimation = false;
            this.updateCurrentComponent(FormComponent.finish);
        }, 8000);
    }

    private onPlaidConnectionFinish = (response: any) => {
        this.showVerifiedCheckmark = true;
        if(response.data.bankAccounts) {
            this.accounts = response.data.bankAccounts;
        }
        setTimeout(() => {
            this.showVerifiedCheckmark = false;
            this.updateCurrentComponent(FormComponent.bankSelection);
        }, 2000);
    }

    private onFileUploadFinish = (response: any, propertyName: string | undefined) => {
        if(propertyName === FormVerificationTexts.propertyNames.IMAGE_ID) {
            this.formInput.verification.idImage = response.data.verificationInfo.imageDownloadUrl;
            MixPanelAnalyticsService.track(AnalyticsSignUpEvents.IdSuccess, {userInfo: this.formInput.business, image: this.formInput.verification.idImage})
        } else if(propertyName === FormVerificationTexts.propertyNames.SIGNUP_PDF){
            this.formInput.verification.signupPdfFile = true;
            MixPanelAnalyticsService.track(AnalyticsSignUpEvents.LeaseUploaded, {userInfo: this.formInput.business});
        }
        this.setSuccessfulResponse(response.data);
    }

    private handleResponseUserInfoIfNeeded = (userInfo: any) => {
        if(!userInfo) {return;}
        this.formInput = {
            welcome: {
                cowork: userInfo.coworkLocation
            },
            plans: {
                plansValue: userInfo.planType
            },
            business: {
                fullName: userInfo.name,
                userEmail: userInfo.email,
                userCompanyName: userInfo.businessName
            },
        };
        if(userInfo.userCellPhone) {
            this.formInput.business.userCellPhone = userInfo.userCellPhone
        }
        if(userInfo.userAddress) {
            this.formInput.business.userAddress = userInfo.userAddress
        }
    }

    private handleResponseRentInfoIfNeeded = (rentInfo: any) => {
        if(!rentInfo) {return;}
        this.formInput.financial = {
            amount: rentInfo.amount
        }
        if(rentInfo.installmentPlan) {
            this.formInput.financial.installmentPlan = rentInfo.installmentPlan;
        }
    }

    private handleResponseLoanInfoIfNeeded = (loanInfo: any) => {
        if(!loanInfo) {return;}
        this.formInput.financial = {
            amount: loanInfo.amount
        }
        if(loanInfo.installmentPlan) {
            this.formInput.financial.installmentPlan =loanInfo.installmentPlan;
        }
        if(loanInfo.reason) {
            this.formInput.financial.fundReason = loanInfo.reason;
        }
    }

    private handleResponseDepositInfoIfNeeded = (depositInfo: any) => {
        if(!depositInfo) {return;}
        this.formInput.financial = {
            isDepositPaid: depositInfo.hasPaidDeposit,
            amount: depositInfo.skipAmount ? " " :  depositInfo.amount
        };
        if(this.formInput.financial.amount) {
            this.showResetFormButton = false;
        }
    };

    private handleResponseVerificationInfoIfNeeded = (verificationInfo: any) => {
        this.formInput.verification = {}
        if(!verificationInfo) {
            return;
        }
        if(verificationInfo.imageDownloadUrl) {
            this.formInput.verification.idImage = verificationInfo.imageDownloadUrl;
            this.isPdfSelectAllowed = true;
        }if(verificationInfo.hasMembershipAgreement) {
            this.formInput.verification.signupPdfFile = true;
        }else {
            this.formInput.verification = {}

        }
    }

    private handleResponsePaymentInfoIfNeeded = (paymentInfo: any) => {
        if(!paymentInfo) {return;}
        this.formInput.plans = {
            plansValue: paymentInfo.planType
        };
        this.isVerified = paymentInfo.finalPrice;
        this.setMonthlyPaymentAmount(paymentInfo.montlyFee);
        this.setInstallmentsPlan(paymentInfo.installmentPlan);
        this.setRepaymetAmount(paymentInfo.repaymentAmount);
    }

    private handleResponseBankAccountsDataIfNeeded = (bankAccounts: any) => {
        if(bankAccounts) {
            this.accounts = bankAccounts;
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/SignUpFormStateStore.ts